/* eslint-disable */
import jQuery from 'jquery';

jQuery(function ($) {
  // $('.ui.sidebar').sidebar({
  //   context: $('.sidebar__wr')
  // });

  $('#toggle').on('click', function () {
    // $('.ui.sidebar').sidebar('toggle');
    $('#menu > .dropdown').trigger('click');
  });

  // $(window).on('resize', function() {
  //   $('.ui.sidebar').sidebar('hide')
  // });

  // $('.js-search-toogle').on('click tap', function() {
  //   $('.js-header-search').toggleClass('active');
  //   return false;
  // });
});
